import {Entity} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'

export class UserAlertEntity extends Entity {
  /**
   * @param {Boolean} activeEmail
   * @param {Boolean} activePush
   * @param {Number} alertId
   * @param {String} alertName
   * @param {String} frequencyNotification
   * @param {Object} filters
   * @param {Number} numOfFiltersSelected
   */

  static getNotAvailableFilters({filters}) {
    const {NOT_AVAILABLE_FILTERS} = ConfigContext.get('alerts')
    const {DEFAULT_FILTERS_SEARCH} = ConfigContext.get('searchFilters')
    const {FILTERS_LABELS} = ConfigContext.get('filtersLabels')

    const notAvailableFilters = NOT_AVAILABLE_FILTERS.map(filter => {
      // The toggle filters (hasPriceDrop, hasStock…) are only active when true, and the search can carry
      // them as `false` when they are off (default is null), so `false` is not an applied filter.
      const filterExists = filters[filter] !== undefined && filters[filter] !== false

      const isDefaultFilter = JSON.stringify(DEFAULT_FILTERS_SEARCH[filter]) === JSON.stringify(filters[filter])

      return filterExists && !isDefaultFilter && {id: filter, label: FILTERS_LABELS[filter], value: filters[filter]}
    }).filter(Boolean)

    return notAvailableFilters
  }

  get activeEmail() {
    return this._activeEmail
  }

  get activePush() {
    return this._activePush
  }

  get alertId() {
    return this._alertId
  }

  get alertName() {
    return this._alertName
  }

  get filters() {
    return this._filters
  }

  get frequencyNotification() {
    return this._frequencyNotification
  }

  get numOfFiltersSelected() {
    return this._numOfFiltersSelected
  }

  getAlertId() {
    return this._alertId
  }

  getFilters() {
    return this._filters
  }

  getValue() {
    return {
      activeEmail: this._activeEmail,
      activePush: this._activePush,
      alertId: this._alertId,
      alertName: this._alertName,
      filters: this._filters,
      frequencyNotification: this._frequencyNotification,
      numOfFiltersSelected: this._numOfFiltersSelected
    }
  }
}
